import { useCallback } from "react";
import { hasRichTextContent } from "../utils/richTextHelpers";

export default function useReportHistory({
  reportHistory,
  setReportHistory,
  fields,
  setFields,
  showStatus,
  getRegionDisplayLabel,
}) {
  const saveCurrentToHistory = useCallback(() => {
    const hasMainContent = hasRichTextContent(fields.befund) || hasRichTextContent(fields.beurteilung);
    if (!hasMainContent) {
      showStatus("Befund oder Beurteilung sind leer.", true);
      return;
    }

    const labelParts = [fields.modalitat, getRegionDisplayLabel(fields.region, fields.modalitat)].filter(Boolean);
    const title = labelParts.length ? labelParts.join(" - ") : "Befund ohne Titel";
    const entry = {
      id: Date.now().toString(),
      title,
      savedAt: new Date().toISOString(),
      fields: { ...fields },
    };

    setReportHistory((prev) => [entry, ...prev].slice(0, 30));
    showStatus("Befund im Verlauf gespeichert ✓");
  }, [fields, getRegionDisplayLabel, setReportHistory, showStatus]);

  const restoreFromHistory = useCallback((entryId) => {
    const entry = reportHistory.find((h) => h.id === entryId);
    if (!entry?.fields) return;
    setFields({ ...entry.fields });
    showStatus(`Verlauf geladen: ${entry.title}`);
  }, [reportHistory, setFields, showStatus]);

  const deleteHistoryEntry = useCallback((entryId) => {
    setReportHistory((prev) => prev.filter((h) => h.id !== entryId));
    showStatus("Eintrag aus Verlauf entfernt ✓");
  }, [setReportHistory, showStatus]);

  const clearHistory = useCallback(() => {
    setReportHistory([]);
    showStatus("Verlauf gelöscht ✓");
  }, [setReportHistory, showStatus]);

  return {
    saveCurrentToHistory,
    restoreFromHistory,
    deleteHistoryEntry,
    clearHistory,
  };
}
